<div class="mat-dialog-content">
  <img [src]="data.images[data.currentIndex].url" class="img-fluid" style="max-width: 100%; height: auto;">
</div>
<div class="mat-dialog-actions">
  <button mat-icon-button (click)="previous()">
    <mat-icon>chevron_left</mat-icon>
  </button>
  <button mat-icon-button (click)="next()">
    <mat-icon>chevron_right</mat-icon>
  </button>
</div>
